import { render, staticRenderFns } from "./SpecialInstructionListItems.vue?vue&type=template&id=35a1700d&scoped=true"
import script from "./SpecialInstructionListItems.vue?vue&type=script&lang=ts"
export * from "./SpecialInstructionListItems.vue?vue&type=script&lang=ts"
import style0 from "./SpecialInstructionListItems.vue?vue&type=style&index=0&id=35a1700d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1700d",
  null
  
)

export default component.exports